import { render, staticRenderFns } from "./sales-order-list.vue?vue&type=template&id=27079a9c&"
import script from "./js/sales-order-list.js?vue&type=script&lang=js&"
export * from "./js/sales-order-list.js?vue&type=script&lang=js&"
import style0 from "./sales-order-list.vue?vue&type=style&index=0&id=27079a9c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports